import React from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';

export interface IForumGridOverlayProps {
  message: string;
}

export function ForumGridOverlay(props: IForumGridOverlayProps) {
  const { message } = props;

  return (
    <GridOverlay>
      <div>
        <i>{message}</i>
      </div>
    </GridOverlay>
  );
}
